<template>
  <div>
    <div class="stockSettingCheck">
      印刷元ファイルを選択し、現在の設定で取込可能かチェックできます。<br /><br />
      <RfidFileUploadArea ref="fileDropArea" btnName="チェック"
        v-on:btn-click="checkFile" v-bind:btnDisable="true">
        <template v-slot:caption>
          ここにCSVファイルをドロップ<br />または、選択してください。<br />
        </template>
      </RfidFileUploadArea>
    </div>

    <!-- Modal -->
    <div class="modal" id="overlay" v-show="modalFlag" @click="closeModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              印刷元ファイルの確認画面（先頭から10件表示）
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span @click="closeModal">&times;</span>
            </button>
          </div>
          <div class="modal-body2" style="overflow-x:auto;">
            <table id="data-table" class="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">個体識別コード</th>
                  <th scope="col">商品コード</th>
                  <th scope="col">管理区分</th>
                  <th scope="col">商品名</th>
                  <th scope="col">数量</th>
                  <th scope="col">JANコード</th>
                  <th scope="col">汎用項目</th>
               </tr>
              </thead>
              <tbody>
                  <tr v-for="(value,index) in csvDetailList" :key="index">
                  <td class="table-cell-wrap mw170 mxw170">{{ value.individualCode }}</td>
                  <td class="table-cell-wrap mw170 mxw130">{{ value.goodsCode }}</td>
                  <td class="table-cell-wrap mw100 mxw100">{{ value.managementDiv === 0 ? '個体管理' : '数量管理' }}</td>
                  <td class="table-cell-wrap mw250 mxw250">{{ value.goodsName }}</td>
                  <td class="table-cell-wrap mw70 mxw70">{{ value.quantity }}</td>
                  <td class="table-cell-wrap mw170 mxw170">{{ value.janCode }}</td>
                  <td class="table-cell-wrap mw170 mxw170">{{ value.generalItem }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="modal fade bd-example-modal-lg" id="Modal_B" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              印刷元ファイルの確認画面（先頭から10件表示）
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body2" style="overflow-x:auto;"></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>/.modal -->
  </div><!-- /.tab-pane -->
</template>

<script>
import RfidFileUploadArea from '@/components/atoms/RfidFileUploadArea'
export default {
  name: 'stock-data-set-print-csv-check',
  components: {
    RfidFileUploadArea
  },
  props: {
    csvDetailList: {
      type: Array,
      default: null
    },
    modalFlag: false
  },
  data () {
    return {
      selectedFileName: '',
      checkMsg: ''
    }
  },

  methods: {
    isRequired (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === ''
    },
    async checkFile (file) {
      if (file !== undefined) {
        this.$emit('getCsvData', file)
      }
    },
    opneModal () {
      this.$emit('isModal', true)
    },
    closeModal () {
      this.$emit('isModal', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/StockDataSetPrintCsvCheck.vue